 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"authentication-authentication-module":"authentication-authentication-module","user-user-module":"user-user-module","default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~2e104ea3":"default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~2e104ea3","default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~fe8e1fc7":"default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~fe8e1fc7","default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~fa45f761":"default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~fa45f761","common":"common","documents-documents-module":"documents-documents-module","default~admission-learner-admission-learner-module~admission-student-admission-student-module~gradua~37e9c133":"default~admission-learner-admission-learner-module~admission-student-admission-student-module~gradua~37e9c133","admission-learner-admission-learner-module":"admission-learner-admission-learner-module","admission-student-admission-student-module":"admission-student-admission-student-module","default~learner-learner-module~student-student-module":"default~learner-learner-module~student-student-module","student-student-module":"student-student-module","graduate-learner-graduate-learner-module":"graduate-learner-graduate-learner-module","graduate-student-graduate-student-module":"graduate-student-graduate-student-module","files-files-module":"files-files-module","organization-organization-module":"organization-organization-module","synt-base-data-synt-base-data-module":"synt-base-data-synt-base-data-module","synthetic-synthetic-module":"synthetic-synthetic-module","utilities-utilities-module":"utilities-utilities-module","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~59921099":"default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~59921099","open-major-management-module":"open-major-management-module","default~account-account-module~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2~73fb8952":"default~account-account-module~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2~73fb8952","account-account-module":"account-account-module","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~1da0df9e":"default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~1da0df9e","khao_sat-khao_sat-module":"khao_sat-khao_sat-module","version-learner-version-learner-module":"version-learner-version-learner-module","version-staff-version-staff-module":"version-staff-version-staff-module","version-student-version-student-module":"version-student-version-student-module","learner-learner-module":"learner-learner-module","staff-staff-module":"staff-staff-module","chuong-trinh-dt-ctdt-module":"chuong-trinh-dt-ctdt-module","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~8dbe6880":"default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~8dbe6880","dashboards-dashboards-module":"dashboards-dashboards-module","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~3b1e6d5d":"default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~3b1e6d5d","bao-cao-ban-dt-module-bao-cao-ban-dt-module":"bao-cao-ban-dt-module-bao-cao-ban-dt-module","bao-cao-ban-khdt-module-bao-cao-ban-khdt-module":"bao-cao-ban-khdt-module-bao-cao-ban-khdt-module","bao-cao-ban-khtc-du-toan-module-bao-cao-ban-khtc-module":"bao-cao-ban-khtc-du-toan-module-bao-cao-ban-khtc-module","bao-cao-ban-qldaqt-module-bao-cao-ban-qldaqt-module":"bao-cao-ban-qldaqt-module-bao-cao-ban-qldaqt-module","bao-cao-ban-tdkt-module-bao-cao-ban-tdkt-module":"bao-cao-ban-tdkt-module-bao-cao-ban-tdkt-module","bao-cao-bcqt-module-bao-cao-bcqt-module":"bao-cao-bcqt-module-bao-cao-bcqt-module","bao-cao-bcqtr-module-bao-cao-bcqtr-module":"bao-cao-bcqtr-module-bao-cao-bcqtr-module","bao-cao-hntc-module-bao-cao-hntc-module":"bao-cao-hntc-module-bao-cao-hntc-module","bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module":"bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module","bao-cao-ban-khcn-module-bao-cao-ban-khcn-module":"bao-cao-ban-khcn-module-bao-cao-ban-khcn-module","bao-cao-ban-ttpc-module-bao-cao-ban-ttpc-module":"bao-cao-ban-ttpc-module-bao-cao-ban-ttpc-module","bao-cao-tccb-module-bao-cao-tccb-module":"bao-cao-tccb-module-bao-cao-tccb-module","bao-cao-van-phong-module-bao-cao-van-phong-module":"bao-cao-van-phong-module-bao-cao-van-phong-module","default~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnptda-module~bao-cao-bctc-module-bao-cao-bctc-modu~1dcbb039":"default~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnptda-module~bao-cao-bctc-module-bao-cao-bctc-modu~1dcbb039","bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnptda-module":"bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnptda-module","default~bao-cao-bctc-module-bao-cao-bctc-module~bao-cao-bctt09-module-bao-cao-bctt09-module":"default~bao-cao-bctc-module-bao-cao-bctc-module~bao-cao-bctt09-module-bao-cao-bctt09-module","bao-cao-bctc-module-bao-cao-bctc-module":"bao-cao-bctc-module-bao-cao-bctc-module","bao-cao-bctt09-module-bao-cao-bctt09-module":"bao-cao-bctt09-module-bao-cao-bctt09-module"}[chunkId]||chunkId) + "-es2015." + {"authentication-authentication-module":"e3089e4a651026b0fbc5","user-user-module":"6b649e111e0b1f45b1d3","default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~2e104ea3":"f999686c9805562d38b7","default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~fe8e1fc7":"347528a5691d9a19262b","default~account-account-module~admission-learner-admission-learner-module~admission-student-admissio~fa45f761":"05a0537015048371d30d","common":"55ae0379aa91cb6a4e50","documents-documents-module":"5bc7edca8d809ca71f4a","default~admission-learner-admission-learner-module~admission-student-admission-student-module~gradua~37e9c133":"61b9bbfdcf2fba447836","admission-learner-admission-learner-module":"15f343c2c20a182f891a","admission-student-admission-student-module":"63d061fd99d0aaacf70a","default~learner-learner-module~student-student-module":"dc57a3cab7ec673f6294","student-student-module":"3355320abacb98d776ee","graduate-learner-graduate-learner-module":"9f3c5431d9f92130ba0b","graduate-student-graduate-student-module":"d3f0f9fb920eb6a48699","files-files-module":"2b8f1b4a48697fe80370","organization-organization-module":"c56d884d8e4fb25408d5","synt-base-data-synt-base-data-module":"270934cec048a9a5515b","synthetic-synthetic-module":"bb19ea20685662799405","utilities-utilities-module":"a2e2568df5af77ddc8d1","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~59921099":"9997981c0de24b0d829c","open-major-management-module":"c0a35cd51e52cfaa29ab","default~account-account-module~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2~73fb8952":"fed2e164ce4f08bf4d72","account-account-module":"6b5c4313cd0bfdb535c1","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~1da0df9e":"4931b4a0a05ff187d1d4","khao_sat-khao_sat-module":"e02dcaffd1f7fc1e0dd4","version-learner-version-learner-module":"400d2b2e564abaa3c6a5","version-staff-version-staff-module":"d535643dabdd5b25ce87","version-student-version-student-module":"9d91b8687ba890331059","learner-learner-module":"97a83e9fc8e8baec831a","staff-staff-module":"8aff512446b4e999947e","chuong-trinh-dt-ctdt-module":"12582e18ed75bbf4211e","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~8dbe6880":"54a5038cb3ce0d4a4c51","dashboards-dashboards-module":"eea40383cc4512100b57","default~bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnp~3b1e6d5d":"ef687aae740dbf83ad82","bao-cao-ban-dt-module-bao-cao-ban-dt-module":"8e1a1bd1c14d9fd28dbc","bao-cao-ban-khdt-module-bao-cao-ban-khdt-module":"e388dbd46d099fb94d33","bao-cao-ban-khtc-du-toan-module-bao-cao-ban-khtc-module":"6dc929a2d5c09a65ee75","bao-cao-ban-qldaqt-module-bao-cao-ban-qldaqt-module":"bee41d57c5a4115c0bf3","bao-cao-ban-tdkt-module-bao-cao-ban-tdkt-module":"be73f78e6f6e6a9be733","bao-cao-bcqt-module-bao-cao-bcqt-module":"b4bb52a28e2ea5887411","bao-cao-bcqtr-module-bao-cao-bcqtr-module":"ff445a690931979dd203","bao-cao-hntc-module-bao-cao-hntc-module":"68e0d88ec7f6df047528","bao-cao-ban-ctsv-module-bao-cao-ban-ctsv-module":"a0ba905a0bc465ab1b1c","bao-cao-ban-khcn-module-bao-cao-ban-khcn-module":"2ca940f4fa30642a4984","bao-cao-ban-ttpc-module-bao-cao-ban-ttpc-module":"cd06295685a5396ef986","bao-cao-tccb-module-bao-cao-tccb-module":"90dd09618c078e668c77","bao-cao-van-phong-module-bao-cao-van-phong-module":"1db6f0b484d6ad9e24b5","default~bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnptda-module~bao-cao-bctc-module-bao-cao-bctc-modu~1dcbb039":"5547c97ee8357b42ee28","bao-cao-ban-dnptda-v2-module-bao-cao-ban-dnptda-module":"e5380452f84eb0d5813c","default~bao-cao-bctc-module-bao-cao-bctc-module~bao-cao-bctt09-module-bao-cao-bctt09-module":"e695fa13e9d0354eb40e","bao-cao-bctc-module-bao-cao-bctc-module":"07521bdf9f09f59f0a54","bao-cao-bctt09-module-bao-cao-bctt09-module":"ec03a46925d82f26d04d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
